import {MinifierEngineContract} from 'common/templating/MinifierEngineContract';
import CleanCSS from 'clean-css';
import {minify as minifyHtml} from 'html-minifier-terser';

export class MinifierEngine implements MinifierEngineContract {
    public async css(content: string): Promise<string> {
        const minifier: CleanCSS.MinifierOutput = new CleanCSS({
            compatibility: 'ie7',
            format: false,
            level: 1,
            sourceMap: false
        });
        const result: CleanCSS.Output = minifier.minify(content);

        return result.styles;
    }

    public async html(content: string): Promise<string> {
        return await minifyHtml(content, {
            collapseBooleanAttributes: true,
            collapseInlineTagWhitespace: true,
            collapseWhitespace: true,
            continueOnParseError: false,
            decodeEntities: false,
            html5: true,
            minifyCSS: true,
            minifyJS: true,
            noNewlinesBeforeTagClose: true,
            preserveLineBreaks: false,
            preventAttributesEscaping: false,
            processConditionalComments: false,
            quoteCharacter: '"',
            removeAttributeQuotes: false,
            removeComments: true,
            removeEmptyAttributes: true,
            removeEmptyElements: true,
            removeOptionalTags: false,
            removeRedundantAttributes: true,
            removeScriptTypeAttributes: false,
            removeStyleLinkTypeAttributes: false,
            removeTagWhitespace: false
        });
    }
}
